export const RemoveVariablesModal: string = 'RemoveVariablesModal';
